import {Injectable} from "@angular/core";
import { Data } from "@angular/router";
import {DataResponse, ListDataResponse} from "src/app/models/http.models";
import { Observable, Observer } from "rxjs";
import {BaseApiService} from "./_baseApiService";
import {AnagraficaDto} from "../../models/anagrafica.models";
import {RegistrationRequest} from "../../models/registrazione.models";
import {AplDto, EsperienzaLavoroDto, MansioniDto} from "../../models/lavoro.models";
import {SharedEnumModelKeyValue} from "../../models/shared.models";
import {
  AnagraficaUtenteAttestatoDto, AnagraficaUtenteConoscenzeDto,
  AnagraficaUtenteIstruzioneDto,
  AnagraficaUtenteLingueDto, AnagraficaUtenteLivelloIstruzioneDto, Attestato, Conoscenze, GetIstruzioneViewModel, Lingua
} from "../../models/istruzione.models";

@Injectable()

export class StudyService extends BaseApiService{

  public getTypeStudyTitleList(model : GetIstruzioneViewModel):Observable<DataResponse<AnagraficaUtenteLivelloIstruzioneDto>>{
    return this.httpService.get(`PortalsIstruzione/GetTipoTitoloStudioList`, model);
  }
  public getProfileStudy(idAnagraficaUtente : number):Observable<DataResponse<AnagraficaUtenteIstruzioneDto>>{
    return this.httpService.get(`PortalsIstruzione/GetAnagraficaUtenteIstruzioneList?idAnagraficaUtente=`+ idAnagraficaUtente);
  }
  public profileStudyUpsert(model: AnagraficaUtenteIstruzioneDto):Observable<DataResponse<Response>>{
    return this.httpService.post(`PortalsIstruzione/AnagraficaUtenteIstruzioneUpdate`, model);
  }
  public profileStudyDelete(id : number):Observable<DataResponse<Response>>{
    return this.httpService.delete(`PortalsIstruzione/AnagraficaUtenteIstruzioneDelete?IdAnagraficaUtenteIstruzione=`+ id);
  }
  public getAttestedTypes():Observable<DataResponse<Attestato>>{
    return this.httpService.get(`PortalsIstruzione/GetTipoAttestati`);
  }
  public getProfileAttested(idAnagraficaUtente : number):Observable<DataResponse<AnagraficaUtenteAttestatoDto>>{
    return this.httpService.get(`PortalsIstruzione/GetAnagraficaUtenteAttestatiList?idAnagraficaUtente=`+ idAnagraficaUtente);
  }
  public profileAttestedUpsert(model : AnagraficaUtenteAttestatoDto):Observable<DataResponse<Response>>{
    return this.httpService.post(`PortalsIstruzione/AnagraficaUtenteAttestatiUpdate`, model);
  }
  public profileAttestedDelete(id : number):Observable<DataResponse<Response>>{
    return this.httpService.delete(`PortalsIstruzione/AnagraficaUtenteAttestatiDelete?idAnagraficaUtenteAttestato=`+id);
  }
  public getProfileLanguage(idAnagraficaUtente : number):Observable<DataResponse<AnagraficaUtenteLingueDto>>{
    return this.httpService.get(`PortalsIstruzione/GetAnagraficaUtenteConoscenzeLinguistiche?idAnagraficaUtente=`+ idAnagraficaUtente);
  }
  public getLanguage():Observable<DataResponse<Lingua>>{
    return this.httpService.get(`PortalsIstruzione/GetLingueList`);
  }
  public getRateLanguage():Observable<DataResponse<SharedEnumModelKeyValue>>{
    return this.httpService.get(`PortalsIstruzione/GetGradoLingueList`);
  }
  public profileLangUpsert(model : AnagraficaUtenteLingueDto):Observable<DataResponse<Response>>{
    return this.httpService.post(`PortalsIstruzione/AnagraficaUtenteLingueUpdate`, model);
  }
  public profileLangdDelete(id : number):Observable<DataResponse<Response>>{
    return this.httpService.delete(`PortalsIstruzione/AnagraficaUtenteLingueDelete?idAnagraficaUtenteLingua=`+id);
  }
  public getComputerKnowledges(idAnagraficaUtente : number):Observable<DataResponse<AnagraficaUtenteConoscenzeDto>>{
    return this.httpService.get(`PortalsIstruzione/GetAnagraficaUtenteConoscenzeInformatiche?idAnagraficaUtente=`+ idAnagraficaUtente);
  }
  public computerKnowledgesUpsert(model: AnagraficaUtenteConoscenzeDto):Observable<DataResponse<Response>>{
    return this.httpService.post(`PortalsIstruzione/AnagraficaUtenteConoscenzaInformaticaUpdate`, model);
  }
  public getKnowledges():Observable<DataResponse<Conoscenze>>{
    return this.httpService.get(`PortalsIstruzione/GetConoscenzeList`);
  }
  public getKnowledgesRate():Observable<DataResponse<SharedEnumModelKeyValue>>{
    return this.httpService.get(`PortalsIstruzione/GetConoscenzeGradoList`);
  }
  public profileComputerKnowledgesDelete(id : number):Observable<DataResponse<Response>>{
    return this.httpService.delete(`PortalsIstruzione/AnagraficaUtenteConoscenzaInformaticaDelete?idAnagraficaUtenteConoscenza=`+id);
  }




}
